import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import { omitUndefined } from "../../utils/lodash.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import CalculatorLayout from "../CalculatorLayout/CalculatorLayout.esm.js";
import { FieldConfig } from "./HomeSaleProceedsCalculator.utils.esm.js";
import HomeSaleProceedsContent from "./HomeSaleProceedsContent.esm.js";
import HomeSaleProceedsFields from "./HomeSaleProceedsFields.esm.js";
const DEFAULT_VALUES = {
  [FieldConfig.desiredSellingPrice.name]: 302e3,
  [FieldConfig.remainingMortgageOwed.name]: 0,
  [FieldConfig.homeImprovement.name]: 0,
  [FieldConfig.cleaningAndPrep.name]: 6e3,
  [FieldConfig.monthlyMortgagePayments.name]: 0,
  [FieldConfig.moving.name]: 500,
  [FieldConfig.agentCommission.name]: 18120,
  [FieldConfig.sellingConcessions.name]: 3020,
  [FieldConfig.closingFees.name]: 1510,
  [FieldConfig.taxes.name]: 3020
};
const HomeSaleProceedsCalculator = ({
  defaultValues
}) => {
  const mergedValues = {
    ...DEFAULT_VALUES,
    ...omitUndefined(defaultValues)
  };
  return /* @__PURE__ */ jsx(CalculatorForm, { fieldStorageKey: "closingCostFields", editorMode: isEditor(), defaultValues: mergedValues, children: /* @__PURE__ */ jsx(CalculatorLayout, { cssOverride: {
    flexDirection: "column-reverse",
    lg: {
      flexDirection: "row"
    }
  }, fields: /* @__PURE__ */ jsx(HomeSaleProceedsFields, {}), content: /* @__PURE__ */ jsx(HomeSaleProceedsContent, {}) }) });
};
export {
  HomeSaleProceedsCalculator as default
};
